import React from "react"
import styled from "styled-components"

import { eq, minWidth } from "utils"

import MBGAd from "components/mbg-ad"
import NetworkAd from "components/network-ad"

const ContentfulAdUnit = ({ className, component, unitName, hideTitle = false }) => {
  const { id, networkAd, layout = "Horizontal Rectangle", image, url, name, device } = component

  if (networkAd) {
    return (
      <Container device={device}>
        <NetworkAd className={className} dataId={id} unitName={unitName} hideTitle={hideTitle} />
      </Container>
    )
  }

  return (
    <MBGAd
      className={className}
      dataId={id}
      widthMobile={layout === "Square" ? 300 : layout === "Horizontal Rectangle" ? 320 : 300}
      widthNonMobile={layout === "Square" ? 300 : layout === "Horizontal Rectangle" ? 728 : 300}
      aspectRatio={image[0].height / image[0].width}
      cloudinaryUrl={image[0].secure_url}
      url={url}
      title={name}
    />
  )
}

export const Container = styled.span`
  ${eq("device", "Desktop / Tablet")`
    display: none;

    ${minWidth.tablet`
      display: block;
    `}
  `}

  ${eq("device", "Mobile")`
    ${minWidth.tablet`
      display: none;
    `}
  `}
`

export default ContentfulAdUnit
